import m from "../../../../geodata/es2015/region/usa/caHigh";
window.am4geodata_region_usa_caHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/caHigh.js
// module id = null
// module chunks = 